module.exports = __webpack_public_path__ + "static/media/twitter.3a1cf623.svg";